// ======================================================================
// File Name       : UserAttributeConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const USER_ATTRIBUTE_TYPE = {
  COURSE: 1,
  BOX: 2,
  ITEM: 3,
  USER: 4,
  GROUP: 5,
  LIVE: 6,
};

export const USER_ATTRIBUTE_KEY_NUM_LIST = [...Array(20)].map((cur, index) => ({
  name: (`${index + 1}`),
  value: index + 1,
}));
